import type {UavPointCloudRepository} from '@/domain/interfaces/UavPointCloudRepository';

export class GetUavPointCloudsByForestMassUuidUseCase {
  constructor(private readonly repository: UavPointCloudRepository) {}
  async execute(forestMassUuid: string) {
    return this.repository.getByForestMassUuid(forestMassUuid);
  }
}
